import type { HttpRequest } from '../types/http-request';

const resetPathPattern = /\/api\/reset\/?$/i;

const requestPathname = (url: string): string | null => {
  try {
    return new URL(url).pathname;
  } catch {
    return null;
  }
};

const resetResponseLooksSuccessful = (request: HttpRequest): boolean => {
  const snippet =
    request.responseBody ??
    request.responseBodyPreview ??
    request.bodyPreview ??
    '';
  return /"ok"\s*:\s*true/.test(snippet);
};

export const isSuccessfulVaultRegistrationRequest = (
  request: HttpRequest,
): boolean => {
  if (request.method.toUpperCase() !== 'POST') {
    return false;
  }
  const pathname = requestPathname(request.url);
  if (!pathname || !resetPathPattern.test(pathname)) {
    return false;
  }
  const status = request.status;
  if (status !== undefined) {
    return (
      (status >= 200 && status < 300) ||
      status === 303 ||
      status === 302 ||
      status === 307 ||
      status === 308
    );
  }
  return resetResponseLooksSuccessful(request);
};

export const hasVaultRegistrationInRequests = (
  requests: Record<string, HttpRequest>,
): boolean =>
  Object.values(requests).some(isSuccessfulVaultRegistrationRequest);
